/* eslint-disable react/no-danger,react/no-array-index-key */
/* eslint-disable react/no-unused-prop-types,
no-console,no-useless-constructor */
import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import ReactTable from 'react-table';
import { formatRoute } from 'react-router-named-routes';
import { withTranslation } from 'react-i18next';
import ContentLoader from 'react-content-loader';
// @material-ui/core icons
import Refresh from '@material-ui/icons/Refresh';
import Check from '@material-ui/icons/Check';
import Person from '@material-ui/icons/PersonOutlined';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Publish from '@material-ui/icons/CloudUpload';
import UnPublish from '@material-ui/icons/CloudDownload';
import AddIco from '@material-ui/icons/AddCircle';
import Edit from '@material-ui/icons/Edit';
// material-ui/ core components
import Zoom from '@material-ui/core/Zoom';
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';
import FormControl from '@material-ui/core/FormControl';
import ListSubheader from '@material-ui/core/ListSubheader';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import LinearProgress from '@material-ui/core/LinearProgress/LinearProgress';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import Card from 'components/UI/Card/Card';
import Badge from 'components/UI/Badge/Badge';
import GridItem from 'components/UI/Grid/GridItem';
import Snackbar from 'components/UI/Snackbar/Snackbar';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
// global variables
import { adStatus, rules } from 'config';
import { AD, USER } from 'routes/paths';
// our components
import RouterContext from 'helpers/routerContext';
import matchedRules, { isFromList } from 'helpers/matchedRulesHelper';
import AdUser from 'components/common/AdUser';
import AdInfo from 'components/common/AdInfo';
import { LoadingAnimation } from 'components/common/Loading';
import AdInfoSidebar from 'components/common/AdInfoSidebar';
import { TableLoader } from 'components/common/TableLoader';
import WithPermission from 'components/User/WithPermission';
import ImageMosaic from 'components/common/ImageMosaic/ImageMosaic';

const hasReviewCategoryRule = ad =>
  ad &&
  Array.isArray(ad.matchedRules) &&
  ad.matchedRules.some(rule => Object.keys(rule)[0] === 'review_category');

const getReviewCategorySuggestion = ad => {
  if (!hasReviewCategoryRule(ad)) {
    return '';
  }
  const reviewCategoryRule = ad.matchedRules.find(
    rule => Object.keys(rule)[0] === 'review_category',
  );
  const payload = reviewCategoryRule.review_category;

  if (payload === null || payload === undefined) {
    return '';
  }
  if (typeof payload === 'string' || typeof payload === 'number') {
    return `${payload}`;
  }
  if (typeof payload === 'object') {
    return `${payload.category_id ||
      payload.subcategoryId ||
      payload.subcategory_id ||
      payload.subcategory ||
      payload.id ||
      ''}`;
  }
  return '';
};

const canShowPublishAction = status =>
  status === adStatus.UNPUBLISHED_BY_MODERATOR ||
  status === adStatus.UNPUBLISHED_BY_PROCESSOR ||
  status === adStatus.TO_REVIEW;

const flattenSubcategories = categories =>
  categories.reduce(
    (acc, category) => [
      ...acc,
      ...(category.subcategories || []).map(subcategory => ({
        id: `${subcategory.id}`,
        title: subcategory.title,
        parentTitle: category.title,
      })),
    ],
    [],
  );

const getSubcategoryLabel = (categories, subcategoryId) => {
  const subcategories = flattenSubcategories(categories || []);
  const selectedSubcategory = subcategories.find(
    item => item.id === `${subcategoryId}`,
  );

  return selectedSubcategory
    ? `${selectedSubcategory.parentTitle} / ${selectedSubcategory.title}`
    : '';
};

class ReviewRulesDetails extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      selectedItems: [],
      expandedRows: [],
      selectedSubcategory: '',
    };
  }

  /**
   * @description
   * Select all items.
   *
   * @param {Array} edges - All ads from api.
   * @returns {undefined} No return.
   */
  handleSelectAll = edges => {
    const { selectedItems } = this.state;
    // if all are selected
    if (selectedItems.length === edges.length) {
      this.setState({ selectedItems: [] });
    } else {
      this.setState({ selectedItems: edges.map(item => item.id) });
    }
  };

  /**
   * @description
   * Select an item.
   *
   * @param {number} id - Id of selected item.
   * @returns {undefined} No return.
   */
  handleSelectItem = id => {
    const { selectedItems } = this.state;
    // if item is selected
    if (selectedItems.indexOf(id) !== -1) {
      this.setState({
        selectedItems: selectedItems.filter(item => item !== id),
      });
    } else {
      this.setState({ selectedItems: [...selectedItems, id] });
    }
  };

  /**
   * @description
   * Handle publish, unpublish action.
   *
   * @param {string} action - Specific action.
   * @param {Array} items - Items to apply an action.
   * @param {string} categoryId - Suggested category from matched rules.
   */
  handleAction = (action, items, categoryId) => {
    const { adPublish, adUnPublish, adApplyRuleAndPublish } = this.props;
    if (action === 'publish') {
      adPublish(items);
    } else if (action === 'unpublish') {
      adUnPublish(items);
    } else if (action === 'applyRuleAndPublish') {
      adApplyRuleAndPublish(items, categoryId);
    }
    this.setState({ selectedItems: [] });
  };

  handleReviewCategoryChange = event => {
    this.setState({ selectedSubcategory: `${event.target.value}` });
  };

  renderReviewCategoryOptions = categories =>
    categories.reduce((items, category) => {
      const subcategoryItems = (category.subcategories || []).map(
        subcategory => (
          <MenuItem
            key={subcategory.id}
            value={`${subcategory.id}`}
            style={{ paddingLeft: 44 }}
          >
            {subcategory.title}
          </MenuItem>
        ),
      );

      return [
        ...items,
        <ListSubheader key={`category-${category.id}`} disableSticky>
          <strong>{category.title}</strong>
        </ListSubheader>,
        ...subcategoryItems,
      ];
    }, []);

  /**
   * @description
   * Redirect to user/read route.
   *
   * @param {number} id - Id of the user to read.
   */
  handleReadUser = id => {
    const history = this.context;
    history.push(formatRoute(USER.DETAILS, { id }));
  };

  /**
   * @description
   * To give a row color depending of column status.
   *
   * @param {number} nodeId - Id of an Ad.
   * @returns {string} Row color.
   */
  renderRowColor = nodeId => {
    const { data } = this.props;
    const node = data.find(ad => ad.id === nodeId);
    if (
      node.status === adStatus.UNPUBLISHED_BY_USER ||
      node.status === adStatus.UNPUBLISHED_BY_USER_DELETED ||
      node.status === adStatus.UNPUBLISHED_BY_USER_BLOCKED
    ) {
      return 'rgba(81, 0, 14, .1)';
    }
    if (node.reviewed) {
      return 'rgba(76, 175, 80, 0.15)';
    }
    return '';
  };

  /**
   * @description
   * Description of ReactTable columns.
   *
   * @param {Array} edges - All ads from api.
   * @returns {Array} Table columns.
   */
  renderColumns = edges => {
    const { selectedItems } = this.state;
    const { classes, t } = this.props;
    return [
      {
        Header: (
          <Checkbox
            onClick={() => this.handleSelectAll(edges)}
            checked={edges && selectedItems.length === edges.length}
            id="allCheckbox"
            checkedIcon={<Check className={classes.checkedIcon} />}
            icon={<Check className={classes.uncheckedIcon} />}
            classes={{
              checked: classes.checked,
            }}
          />
        ),
        accessor: 'checkbox',
        sortable: false,
        filterable: false,
        maxWidth: 58,
      },
      {
        Header: (
          <span className={classes.headerField}>
            {t('ad.list.headers.title')}
          </span>
        ),
        accessor: 'title',
        sortable: false,
        filterable: false,
        minWidth: 300,
      },
      {
        Header: (
          <span className={classes.headerField}>
            {t('ad.list.headers.user')}
          </span>
        ),
        accessor: 'user',
        sortable: false,
        filterable: false,
        maxWidth: 220,
      },
      {
        Header: (
          <span className={classes.headerField}>
            {t('ad.list.headers.ipScore')}
          </span>
        ),
        accessor: 'ipScore',
        sortable: false,
        filterable: false,
        minWidth: 130,
      },
      {
        Header: (
          <span className={classes.headerField}>
            {t('review_queue.headers.rules')}
          </span>
        ),
        accessor: 'rules',
        sortable: false,
        filterable: false,
        minWidth: 150,
      },
      {
        Header: (
          <span className={classes.headerField}>
            <p>{t('ad.list.headers.status')}</p>
          </span>
        ),
        accessor: 'status',
        sortable: false,
        filterable: false,
        maxWidth: 250,
      },
      {
        Header: (
          <span className={classes.headerField} style={{ textAlign: 'center' }}>
            <p>{t('ad.list.headers.actions')}</p>
          </span>
        ),
        accessor: 'actions',
        sortable: false,
        filterable: false,
        maxWidth: 250,
      },
      {
        expander: true,
        show: false,
      },
    ];
  };

  /**
   * @description
   * Map the data from api to ReactTable rows.
   *
   * @param {Array} edges - All ads from api.
   * @returns {Array} Table rows.
   */
  renderRows = edges => {
    const { selectedItems, expandedRows } = this.state;
    const { classes, t } = this.props;
    return edges.map(node => ({
      id: node.id,
      checkbox: (
        <Checkbox
          onClick={() => {
            this.handleSelectItem(node.id);
          }}
          checked={selectedItems.indexOf(node.id) !== -1}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
          }}
        />
      ),
      title: (
        <WithPermission
          alt={
            <React.Fragment>
              <div
                id={`ad-title-${node.id}`}
                data-cy="adTitle"
                className={classes.adTitleContainer}
              >
                {node.readyImages && (
                  <ImageMosaic
                    images={node.readyImages.map(({ id, urls }) => ({
                      id,
                      ...urls,
                    }))}
                  />
                )}
                <div
                  style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}
                >
                  <WithPermission
                    allowPermissions={[
                      'view_autopaidad',
                      'view_ownership_autopaidad',
                    ]}
                  >
                    {node.isAuto && (
                      <small className={classes.adAuto}>AUTO</small>
                    )}
                  </WithPermission>
                  <div className={classes.idAndDate}>
                    <p>
                      <b data-cy={node.id}>ID: {node.id}</b>
                      {node.flagCount > 0 && (
                        <span style={{ marginLeft: 8 }}>
                          <Badge color="danger">{node.flagCount}</Badge>
                        </span>
                      )}
                    </p>
                    <p
                      className={classes.modificationDate}
                      style={{ marginLeft: 8 }}
                    >
                      <Person />
                      {node.updatedOnByUser && (
                        <Moment
                          date={node.updatedOnByUser}
                          format="D MMM Y, HH:mm"
                        />
                      )}
                    </p>
                  </div>
                  <div className={classes.searchFieldContainer}>
                    <span
                      data-cy="adCategory"
                      style={{ padding: '0', margin: 0 }}
                    >
                      {node.subcategory.parentCategory.title}
                    </span>
                    <span className={classes.adIconBread}>
                      <ArrowForward color="disabled" />
                    </span>
                    <span
                      data-cy="adSubcategory"
                      style={{ padding: '0', margin: 0 }}
                    >
                      {node.subcategory.title}
                    </span>
                  </div>
                  <p className={classes.adTitle}>{node.title}</p>
                </div>
              </div>
            </React.Fragment>
          }
          allowPermissions={['view_ad']}
        >
          <Button
            color="primary"
            simple
            className={['read', classes.adBtns, classes.titleBtn].join(' ')}
            id={`ad-title-${node.id}`}
            onClick={() => {
              if (expandedRows.indexOf(node.id) !== -1) {
                this.setState({
                  expandedRows: expandedRows.filter(item => item !== node.id),
                });
              } else {
                this.setState({ expandedRows: [...expandedRows, node.id] });
              }
            }}
          >
            <div
              style={{ padding: '8px 0' }}
              id={`ad-title-${node.id}`}
              data-cy="adTitle"
            >
              {node.readyImages && (
                <ImageMosaic
                  images={node.readyImages.map(({ id, urls }) => ({
                    id,
                    ...urls,
                  }))}
                />
              )}
              <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                <WithPermission
                  allowPermissions={[
                    'view_autopaidad',
                    'view_ownership_autopaidad',
                  ]}
                >
                  {node.isAuto && (
                    <small className={classes.adAuto}>AUTO</small>
                  )}
                </WithPermission>
                <div className={classes.idAndDate}>
                  <p>
                    <b data-cy={node.id}>ID: {node.id}</b>
                    {node.flagCount > 0 && (
                      <span style={{ marginLeft: 8 }}>
                        <Badge color="danger">{node.flagCount}</Badge>
                      </span>
                    )}
                  </p>
                  <p
                    className={classes.modificationDate}
                    style={{ marginLeft: 8 }}
                  >
                    <Person />
                    {node.updatedOnByUser && (
                      <Moment
                        date={node.updatedOnByUser}
                        format="D MMM Y, HH:mm"
                      />
                    )}
                  </p>
                </div>
                <div className={classes.searchFieldContainer}>
                  <span
                    data-cy="adCategory"
                    style={{ padding: '0', margin: 0 }}
                  >
                    {node.subcategory.parentCategory.title}
                  </span>
                  <span className={classes.adIconBread}>
                    <ArrowForward color="disabled" />
                  </span>
                  <span
                    data-cy="adSubcategory"
                    style={{ padding: '0', margin: 0 }}
                  >
                    {node.subcategory.title}
                  </span>
                </div>

                <p className="title">{node.title}</p>
              </div>
            </div>
          </Button>
        </WithPermission>
      ),
      user: (
        <div data-cy="adUserInfo" className={classes.adUserContainer}>
          {node.user ? (
            <WithPermission
              alt={<span>{node.user.fullname}</span>}
              allowPermissions={['view_user']}
            >
              <Button
                simple
                color="primary"
                className={['read', classes.adBtns, classes.titleBtn].join(' ')}
                onClick={() => this.handleReadUser(node.user.id)}
              >
                {node.user.fullname}
              </Button>
            </WithPermission>
          ) : (
            <b>{node.name}</b>
          )}
          <Button
            simple
            color="primary"
            className={['read', classes.adBtns, classes.titleBtn].join(' ')}
          >
            {node.user ? node.user.email : node.email}
          </Button>
          <p data-cy="adUserPhone" key={`user-phone-${node.id}`}>
            {node.user ? node.user.phone : node.phone}
          </p>
        </div>
      ),
      ipScore: (
        <React.Fragment>
          <div className={[classes.botScore, classes.idAndDate].join(' ')}>
            <AddIco />
            <a
              className={['read', classes.adBtns, classes.scoreLink].join(' ')}
              href={`${AD.LIST}?sameOwnerAds=${node.id}`}
              rel="noopener noreferrer"
              target="_blank"
              style={{ float: 'left' }}
            >
              {node.botScoreInsert !== null
                ? node.botScoreInsert
                : t('common.unknown')}
            </a>
            <span>{node.countryInsert || t('common.unknown')}</span>
            <span style={{ marginLeft: '8px' }}>
              {node.ipInsert || t('common.unknown')}
            </span>
          </div>
          {node.updateCount > 0 && (
            <React.Fragment>
              <div className={[classes.botScore, classes.idAndDate].join(' ')}>
                <Edit />
                <a
                  color="primary"
                  className={['read', classes.adBtns, classes.scoreLink].join(
                    ' ',
                  )}
                  href={`${AD.LIST}?sameOwnerAds=${node.id}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ float: 'left' }}
                >
                  {node.botScoreUpdate !== null
                    ? node.botScoreUpdate
                    : t('common.unknown')}
                </a>
                <span>{node.countryUpdate || t('common.unknown')}</span>
                <span style={{ marginLeft: '8px' }}>
                  {node.ipUpdate || t('common.unknown')}
                </span>
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      ),
      rules:
        node.matchedRules &&
        Array.isArray(node.matchedRules) &&
        node.matchedRules.map((matchedRule, key) => {
          if (!isFromList(matchedRule)) {
            return matchedRules(node, classes, t, matchedRule);
          }
          return (
            <div
              key={`mr-list-${node.id}-${key}`}
              className={classes.matchedRule}
              dangerouslySetInnerHTML={{
                __html: matchedRules(node, classes, t, matchedRule),
              }}
            />
          );
        }),
      status: <span data-cy="status">{this.renderCellStatus(node)}</span>,
      actions: selectedItems.indexOf(node.id) === -1 && (
        // we've added some custom button actions
        <div className="actions-center">
          {/* use this button to unpublish the data row */}
          {(node.status === adStatus.PUBLISHED_BY_MODERATOR ||
            node.status === adStatus.PUBLISHED_BY_PROCESSOR ||
            node.status === adStatus.TO_REVIEW) && (
            <WithPermission allowPermissions={['publish_ad']}>
              <Tooltip
                placement="top"
                TransitionComponent={Zoom}
                title={
                  <React.Fragment>
                    {t('common.unpublish')}
                    <span className={classes.arrow} />
                  </React.Fragment>
                }
                classes={{
                  tooltip: classes.bootstrapTooltip,
                  tooltipPlacementTop: classes.bootstrapPlacementTop,
                }}
              >
                <Button
                  data-cy="adPublishOrUnpublishBtn"
                  id={`unpublish-ad-${node.id}`}
                  justIcon
                  onClick={() => this.handleAction('unpublish', [node.id])}
                  className={`ad-published-${node.id}`}
                  color="danger"
                >
                  <UnPublish />
                </Button>
              </Tooltip>
            </WithPermission>
          )}
          {/* use this button to publish the data row */}
          {(node.status === adStatus.UNPUBLISHED_BY_MODERATOR ||
            node.status === adStatus.UNPUBLISHED_BY_PROCESSOR ||
            node.status === adStatus.TO_REVIEW) && (
            <WithPermission allowPermissions={['publish_ad']}>
              <Tooltip
                placement="top"
                TransitionComponent={Zoom}
                title={
                  <React.Fragment>
                    {t('common.publish')}
                    <span className={classes.arrow} />
                  </React.Fragment>
                }
                classes={{
                  tooltip: classes.bootstrapTooltip,
                  tooltipPlacementTop: classes.bootstrapPlacementTop,
                }}
              >
                <Button
                  data-cy="adPublishOrUnpublishBtn"
                  id={`publish-ad-${node.id}`}
                  justIcon
                  onClick={() => this.handleAction('publish', [node.id])}
                  className={`ad-unpublished-${node.id}`}
                  color="success"
                  style={{ marginLeft: '4px' }}
                >
                  <Publish />
                </Button>
              </Tooltip>
            </WithPermission>
          )}
          {canShowPublishAction(node.status) && hasReviewCategoryRule(node) && (
            <WithPermission allowPermissions={['publish_ad']}>
              <Button
                data-cy="adApplyRuleAndPublishBtn"
                justIcon
                onClick={() =>
                  this.handleAction(
                    'applyRuleAndPublish',
                    [node.id],
                    getReviewCategorySuggestion(node),
                  )
                }
                className={`ad-apply-rule-publish-${node.id}`}
                color="info"
                style={{ marginLeft: '4px' }}
              >
                <Publish />
              </Button>
            </WithPermission>
          )}
        </div>
      ),
    }));
  };

  /**
   * @description
   * Render Status cell.
   *
   * @param {Object} node - An ad.
   * @returns {*} Status cell.
   */
  renderCellStatus = node => {
    const { classes, t } = this.props;

    switch (node.status) {
      case adStatus.PENDING_VERIFICATION:
        return (
          <h6 className={`${classes.cellStatus} ${classes.pendingTag}`}>
            {t('ad.list.ad_status.pending_verification')}
          </h6>
        );
      case adStatus.PENDING_PROCESSING:
        return (
          <h6
            id={`ad-pending-processing-${node.id}`}
            className={`${classes.cellStatus} ${classes.pendingTag}`}
          >
            {t('ad.list.ad_status.pending_processing')}
          </h6>
        );
      case adStatus.PROCESSING:
        return (
          <h6 className={`${classes.cellStatus} ${classes.pendingTag}`}>
            {t('ad.list.ad_status.processing')}
          </h6>
        );
      case adStatus.TO_REVIEW:
        return (
          <h6 className={`${classes.cellStatus} ${classes.pendingTag}`}>
            {t('ad.list.ad_status.to_review')}
          </h6>
        );
      case adStatus.UNPUBLISHED_BY_USER:
        return (
          <h6 className={`${classes.cellStatus} ${classes.deletedTag}`}>
            {t('ad.list.ad_status.unpublished_by_user')}
          </h6>
        );
      case adStatus.UNPUBLISHED_BY_USER_DELETED:
        return (
          <h6 className={`${classes.cellStatus} ${classes.deletedTag}`}>
            {t('ad.list.ad_status.unpublished_by_user_deleted')}
          </h6>
        );
      case adStatus.UNPUBLISHED_BY_USER_BLOCKED:
        return (
          <h6 className={`${classes.cellStatus} ${classes.deletedTag}`}>
            {t('ad.list.ad_status.unpublished_by_user_blocked')}
          </h6>
        );
      case adStatus.PUBLISHED_BY_MODERATOR:
        return (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.published_by_moderator')}
          </h6>
        );
      case adStatus.UNPUBLISHED_BY_MODERATOR:
        return (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.unpublished_by_moderator')}
          </h6>
        );
      case adStatus.PUBLISHED_BY_PROCESSOR:
        return (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.published_by_processor')}
          </h6>
        );
      case adStatus.UNPUBLISHED_BY_PROCESSOR:
        return (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.unpublished_by_processor')}
          </h6>
        );
      default:
        break;
    }
    return null;
  };

  /**
   * @description
   * Map Loading index Rows with itemProcessing.
   *
   * @param {Object} itemProcessing - Ids of items that is processing.
   * @param {Object} edges - Edges of connection data.
   */
  mapExpandedRows = (itemProcessing, edges) => {
    const { expandedRows } = this.state;
    const latestExpandedRows = {};
    edges.forEach((value, index) => {
      if (
        itemProcessing.includes(value.id) ||
        expandedRows.includes(value.id)
      ) {
        latestExpandedRows[index] = true;
      }
    });
    return latestExpandedRows;
  };

  renderAdDetails = rowIndex => {
    const { data, t } = this.props;
    const ad = data.filter(item => item.id === rowIndex)[0];

    return (
      <>
        <AdUser data={{ ad }} />
        <AdInfo
          data={{ ad }}
          loading={!ad}
          link={
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={formatRoute(AD.DETAILS, { id: ad.id })}
              className="link"
            >
              {t('ad.details.see_ad')}
            </a>
          }
        />
      </>
    );
  };

  /**
   * @description
   * Render Filter, Paginator and ReactTable components.
   * @returns {*} Paginator and ReactTable components.
   */
  render() {
    const {
      rule,
      data,
      baseAd,
      loading,
      fullLoading,
      classes,
      refresh,
      itemProcessing,
      t,
      failedIds,
      showNotification,
      closeNotification,
      adUnPublishBaseAd,
      adPublishBaseAd,
      adActionLoadingBaseAd,
      categories,
      adApplyRuleAndPublishBaseAd,
    } = this.props;
    const { selectedItems, expandedRows, selectedSubcategory } = this.state;
    const isReviewCategoryRule = rule === rules.REVIEW_CATEGORY;
    const baseAdExist = Object.keys(baseAd).length !== 0;
    const suggestedSubcategory =
      baseAdExist && baseAd.ad ? getReviewCategorySuggestion(baseAd.ad) : '';
    const subcategories = flattenSubcategories(categories || []);
    const selectedSubcategoryId = selectedSubcategory || suggestedSubcategory;
    const selectedSubcategoryExists = subcategories.some(
      item => item.id === selectedSubcategoryId,
    );
    const currentSubcategory = selectedSubcategoryExists
      ? selectedSubcategoryId
      : '';
    const showApplyRuleAndPublish =
      isReviewCategoryRule &&
      baseAdExist &&
      hasReviewCategoryRule(baseAd.ad) &&
      canShowPublishAction(baseAd.ad.status);
    const showReviewCategorySession =
      isReviewCategoryRule && showApplyRuleAndPublish;
    const rows = this.renderRows(data, fullLoading);
    const cols = this.renderColumns(data);
    const latestExpandedRows = this.mapExpandedRows(itemProcessing, data);

    return (
      <React.Fragment>
        <Snackbar
          place="tc"
          color="danger"
          message={t(`common.failed_bulk_action`, {
            count: failedIds.length,
          })}
          open={showNotification}
          closeNotification={closeNotification}
          close
        />
        <div className={classes.pageContainer}>
          <GridContainer justify="space-between" alignItems="center">
            <GridItem>
              <h3 className={classes.title}>
                {t('review_rules.title', {
                  ruleName: `"${t(`review_rules.${rule}`)}"`,
                })}
              </h3>
            </GridItem>
            <GridItem>
              <Button
                color="primary"
                simple
                className={classes.showFilters}
                onClick={() => refresh()}
                id="refresh"
                key="refresh"
              >
                <Refresh />
                {t('ad.filters.update')}
              </Button>
            </GridItem>
          </GridContainer>

          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={6}
              lg={4}
              style={{
                overflowY: 'auto',
                maxHeight: '80vh',
              }}
            >
              <div
                style={{
                  position: 'sticky',
                  zIndex: 2,
                  top: 15,
                  textAlign: 'center',
                }}
              >
                <Card>
                  {adActionLoadingBaseAd ? (
                    <div className={classes.actionsLoader}>
                      <LoadingAnimation />
                    </div>
                  ) : (
                    <div className={classes.permissionsContainer}>
                      {baseAdExist &&
                        (baseAd.ad.status === adStatus.PUBLISHED_BY_MODERATOR ||
                          baseAd.ad.status ===
                            adStatus.PUBLISHED_BY_PROCESSOR ||
                          baseAd.ad.status === adStatus.TO_REVIEW) && (
                          <WithPermission allowPermissions={['publish_ad']}>
                            <Tooltip
                              placement="top"
                              TransitionComponent={Zoom}
                              title={
                                <React.Fragment>
                                  {t('common.unpublish')}
                                  <span className={classes.arrow} />
                                </React.Fragment>
                              }
                              classes={{
                                tooltip: classes.bootstrapTooltip,
                                tooltipPlacementTop:
                                  classes.bootstrapPlacementTop,
                              }}
                            >
                              <Button
                                data-cy="adUnpublishButton"
                                simple
                                id="baseAd-unpublish"
                                onClick={() =>
                                  adUnPublishBaseAd([baseAd.ad.id])
                                }
                                className={classes.actionsBtnLabel}
                                color="danger"
                              >
                                <UnPublish />
                                <span>{t('common.unpublish')}</span>
                              </Button>
                            </Tooltip>
                          </WithPermission>
                        )}
                      {baseAdExist &&
                        (baseAd.ad.status ===
                          adStatus.UNPUBLISHED_BY_MODERATOR ||
                          baseAd.ad.status ===
                            adStatus.UNPUBLISHED_BY_PROCESSOR ||
                          baseAd.ad.status === adStatus.TO_REVIEW) && (
                          <WithPermission allowPermissions={['publish_ad']}>
                            <Tooltip
                              placement="top"
                              TransitionComponent={Zoom}
                              title={
                                <React.Fragment>
                                  {t('common.publish')}
                                  <span className={classes.arrow} />
                                </React.Fragment>
                              }
                              classes={{
                                tooltip: classes.bootstrapTooltip,
                                tooltipPlacementTop:
                                  classes.bootstrapPlacementTop,
                              }}
                            >
                              <Button
                                data-cy="adPublishButton"
                                simple
                                color="success"
                                id="baseAd-publish"
                                onClick={() => adPublishBaseAd([baseAd.ad.id])}
                                className={classes.actionsBtnLabel}
                              >
                                <Publish />
                                <span className={classes.actionsBtnLabel}>
                                  {t('common.publish')}
                                </span>
                              </Button>
                            </Tooltip>
                          </WithPermission>
                        )}
                    </div>
                  )}
                </Card>
              </div>
              {baseAdExist && <AdUser data={baseAd} />}
              <AdInfo data={baseAd} loading={!baseAdExist} />
              {baseAdExist && <AdInfoSidebar data={baseAd} />}
            </GridItem>
            {showReviewCategorySession && (
              <GridItem
                xs={12}
                sm={12}
                md={6}
                lg={8}
                style={{
                  overflowY: 'auto',
                  maxHeight: '80vh',
                }}
              >
                <Card>
                  <div style={{ padding: '16px', marginBottom: '12px' }}>
                    <h5>Review category</h5>
                    <FormControl fullWidth>
                      <Select
                        id="review-category-select"
                        value={currentSubcategory}
                        onChange={this.handleReviewCategoryChange}
                        displayEmpty
                        renderValue={value =>
                          value
                            ? getSubcategoryLabel(categories, value)
                            : 'Select'
                        }
                        inputProps={{
                          id: 'review-category-select',
                          name: 'review-category-select',
                        }}
                      >
                        <MenuItem value="">Select</MenuItem>
                        {this.renderReviewCategoryOptions(categories)}
                      </Select>
                    </FormControl>
                    <WithPermission allowPermissions={['publish_ad']}>
                      <Button
                        data-cy="reviewCategoryApplyRuleAndPublishButton"
                        simple
                        color="info"
                        id="review-category-apply-rule-publish"
                        onClick={() =>
                          adApplyRuleAndPublishBaseAd(currentSubcategory)
                        }
                        disabled={!currentSubcategory}
                        className={classes.actionsBtnLabel}
                        style={{ marginTop: 12 }}
                      >
                        <Publish />
                        <span className={classes.actionsBtnLabel}>
                          {t('common.apply_rule_and_publish')}
                        </span>
                      </Button>
                    </WithPermission>
                  </div>
                </Card>
              </GridItem>
            )}
            {!isReviewCategoryRule && (
              <GridItem
                xs={12}
                sm={12}
                md={6}
                lg={8}
                style={{
                  overflowY: 'auto',
                  maxHeight: '80vh',
                }}
              >
                <div className={classes.contentContainer}>
                  <div
                    className={[
                      classes.loadingLineContainer,
                      classes.topLine,
                    ].join(' ')}
                  >
                    {fullLoading && (
                      <LinearProgress
                        classes={{
                          barColorPrimary: classes.loadingLine,
                        }}
                      />
                    )}
                  </div>
                  <GridContainer>
                    <GridItem
                      className={[
                        classes.groupActions,
                        classes.z1,
                        classes.loteActionsAnimation,
                        selectedItems.length > 0
                          ? classes.showLote
                          : classes.hideLote,
                      ].join(' ')}
                      xs={12}
                      style={{ zIndex: 4 }}
                    >
                      <WithPermission allowPermissions={['publish_ad']}>
                        <Button
                          color="danger"
                          simple
                          size="lg"
                          onClick={() =>
                            this.handleAction('unpublish', selectedItems)
                          }
                          id="unpublishAd"
                        >
                          <UnPublish />
                          {t('common.unpublish')}
                        </Button>
                        <Button
                          color="success"
                          simple
                          size="lg"
                          onClick={() =>
                            this.handleAction('publish', selectedItems)
                          }
                          id="publishAd"
                        >
                          <Publish />
                          {t('common.publish')}
                        </Button>
                      </WithPermission>
                    </GridItem>
                    <GridItem
                      className={[
                        classes.z2,
                        classes.loteActionsAnimation,
                        selectedItems.length > 0
                          ? classes.hideLote
                          : classes.showLote,
                      ].join(' ')}
                      xs={12}
                    >
                      <GridContainer justify="flex-end" alignItems="center">
                        <GridItem xs={12} sm={8} md={6} lg={4}>
                          {fullLoading && (
                            <ContentLoader height={67} width={327} speed={2}>
                              <path
                                // eslint-disable-next-line max-len
                                d="M199,16 L304,16 C307.313708,16 310,18.6862915 310,22 L310,46 C310,49.3137085 307.313708,52 304,52 L199,52 C195.686292,52 193,49.3137085 193,46 L193,22 C193,18.6862915 195.686292,16 199,16 Z M25.9861352,27.0121317 L70.0138648,27.0121317 C74.4244855,27.0121317 78,30.5876462 78,34.9982669 C78,39.4088876 74.4244855,42.9844021 70.0138648,42.9844021 L25.9861352,42.9844021 C21.5755145,42.9844021 18,39.4088876 18,34.9982669 C18,30.5876462 21.5755145,27.0121317 25.9861352,27.0121317 Z M103.986135,27.0121317 L148.013865,27.0121317 C152.424485,27.0121317 156,30.5876462 156,34.9982669 C156,39.4088876 152.424485,42.9844021 148.013865,42.9844021 L103.986135,42.9844021 C99.5755145,42.9844021 96,39.4088876 96,34.9982669 C96,30.5876462 99.5755145,27.0121317 103.986135,27.0121317 Z"
                                fill="#D8D8D8"
                              />
                            </ContentLoader>
                          )}
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                    <GridItem xs={12} className={classes.z3}>
                      <GridContainer>
                        <GridItem xs={12}>
                          {loading ? (
                            <TableLoader />
                          ) : (
                            <ReactTable
                              data={rows}
                              filterable
                              columns={cols}
                              loading={loading}
                              pageSize={data.length}
                              showPagination={false}
                              className={[
                                '-striped -highlight',
                                classes.tbl,
                              ].join(' ')}
                              expanded={latestExpandedRows}
                              SubComponent={({ original }) => {
                                if (expandedRows.includes(original.id))
                                  return this.renderAdDetails(original.id);
                                return (
                                  <div className={classes.loading}>
                                    <LoadingAnimation />
                                  </div>
                                );
                              }}
                              getTrProps={(state, rowInfo) => ({
                                style: {
                                  backgroundColor:
                                    rowInfo &&
                                    (selectedItems.indexOf(
                                      rowInfo.original.id,
                                    ) !== -1
                                      ? 'rgba(171, 221, 250, .8)'
                                      : this.renderRowColor(
                                          rowInfo.original.id,
                                        )),
                                  borderLeft:
                                    rowInfo &&
                                    failedIds.indexOf(rowInfo.original.id) !==
                                      -1
                                      ? '4px solid red'
                                      : '',
                                },
                              })}
                              noDataText={t('common.no_data')}
                              minRows={8}
                            />
                          )}
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </div>
              </GridItem>
            )}
          </GridContainer>
        </div>
      </React.Fragment>
    );
  }
}

/**
 * ReviewRulesDetails PropTypes
 * @param classes - prop styles received from withStyles
 * @param rule - prop to know what rule is currently in review
 * @param data - prop ads query's results
 * @param baseAd - prop ad query's results
 * @param itemProcessing - id of items that is processing
 * @param loading - prop ads query or mutations status
 * @param fullLoading - prop ads loading data from query
 * @param t - prop from HOC with string translations
 * @param failedIds - id of items that was failed after bulk action
 * @param showNotification - prop to know if notification will be showed or not
 * @callback adPublish - callback to publish elements
 * @callback adPublishBaseAd - callback to publish base ad
 * @callback adUnPublish - callback to unpublish elements
 * @callback adUnPublishBaseAd - callback to unpublish base ad
 * @callback refresh - callback to refresh page
 * @callback closeNotification - callback to close notification
 * @callback adActionLoadingBaseAd - show loading when user taps base ad
 */

ReviewRulesDetails.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  rule: PropTypes.string.isRequired,
  data: PropTypes.instanceOf(Array).isRequired,
  baseAd: PropTypes.shape({}).isRequired,
  itemProcessing: PropTypes.instanceOf(Array).isRequired,
  adPublish: PropTypes.func.isRequired,
  adUnPublish: PropTypes.func.isRequired,
  adApplyRuleAndPublish: PropTypes.func,
  adPublishBaseAd: PropTypes.func.isRequired,
  adUnPublishBaseAd: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fullLoading: PropTypes.bool.isRequired,
  adActionLoadingBaseAd: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  failedIds: PropTypes.instanceOf(Array).isRequired,
  showNotification: PropTypes.bool.isRequired,
  closeNotification: PropTypes.func.isRequired,
  categories: PropTypes.instanceOf(Array),
  adApplyRuleAndPublishBaseAd: PropTypes.func,
};

ReviewRulesDetails.defaultProps = {
  categories: [],
  adApplyRuleAndPublish: () => {},
  adApplyRuleAndPublishBaseAd: () => Promise.resolve(),
};

// to fix: The withStyles HOC set contextTypes to a children component
// and it have problem with contextType assigned to PermissionList component
// This is a small hack, with intermediary Component to resolved it temporally
const AdWrapper = props => <ReviewRulesDetails {...props} />;

export default withTranslation()(withStyles(extendedTablesStyle)(AdWrapper));
